import { BRAND_ORDER_RECAP_UPDATE } from "constants/action-types";
import siteConfig from "site-config";
import { format } from "lib/globalize-util";
import { add as snackbarAdd } from "actions/snackbars";
import { IRequestAction, baseActionEpic } from "epics/base-epic";

export const updateOrderRecapEpic = baseActionEpic<IRequestAction>(
    BRAND_ORDER_RECAP_UPDATE.START,
    (action) => ({ method: "POST", body: action.payload, url: `${siteConfig.api}/brand/orders/order-recap` }),
    ({ response }) => [
        {
            payload: response,
            type: BRAND_ORDER_RECAP_UPDATE.SUCCESS,
        },
        snackbarAdd({ message: format("Order Recap fields updated") }),
    ],
    {
        checkErrorStatus: () => {
            throw new Error(format("Error saving order recap"));
        },
    },
);
